import cssifyObject from 'css-in-js-utils/lib/cssifyObject';

export default function cssifyFontFace(fontFace) {
  return '@font-face{' + cssifyObject(fontFace) + '}';
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/fela-bindings/node_modules/fela/es/cssifyFontFace.js
// module id = 1129
// module chunks = 0